// src/iframeUtils.js
export function sendHeightToParent() {
    const height = document.documentElement.scrollHeight;
    window.parent.postMessage({ height: height }, '*');

  }
  
  export function initHeightObserver() {
    sendHeightToParent();

    window.addEventListener('load', sendHeightToParent);
  
    const observer = new MutationObserver(sendHeightToParent);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  
    return () => {
      window.removeEventListener('load', sendHeightToParent);
      observer.disconnect();
    };
  }
  